/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type InsertSubOrgMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  parent_organization_id: Types.Scalars['uuid']['input'];
}>;

export type InsertSubOrgMutation = {
  __typename?: 'mutation_root';
  insert_organizations_one?: { __typename?: 'organizations'; id: string } | null;
};

export const InsertSubOrgDocument = `
    mutation InsertSubOrg($name: String!, $parent_organization_id: uuid!) {
  insert_organizations_one(
    object: {name: $name, parent_organization_id: $parent_organization_id}
  ) {
    id
  }
}
    ` as string & TypedDocumentNode<InsertSubOrgMutation, InsertSubOrgMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    InsertSubOrg: build.mutation<InsertSubOrgMutation, InsertSubOrgMutationVariables>({
      query: (variables) => ({ document: InsertSubOrgDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useInsertSubOrgMutation } = injectedRtkApi;
